export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-200/80 pt-16 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <a
              href="#hero"
              onClick={(e) => handleScroll(e, '#hero')}
              className="text-xl font-heading text-primary-500 mb-4 inline-block cursor-pointer"
            >
              在线吃瓜
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mt-3">
              免费在线吃瓜平台，每日更新最新热门八卦资讯。
              无需注册、无需付费，打开即看。
              全网吃瓜第一入口，百万瓜友的选择。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h3>
            <div className="space-y-2.5">
              {[
                { label: '平台特色', href: '#features' },
                { label: '热门专题', href: '#carousel' },
                { label: '吃瓜索引', href: '#index' },
                { label: '吃瓜热度榜', href: '#ranking' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">更多内容</h3>
            <div className="space-y-2.5">
              {[
                { label: '精选瓜文', href: '#cards' },
                { label: '吃瓜视频', href: '#media' },
                { label: '瓜友热评', href: '#comments' },
                { label: '热门话题', href: '#topics' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <h3 className="text-sm font-semibold text-foreground-900 mb-3">关注我们</h3>
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-xl bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <span className="w-9 h-9 rounded-xl bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </span>
                <span className="w-9 h-9 rounded-xl bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-lg"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2023 - {new Date().getFullYear()} 在线吃瓜. 本站为内容聚合平台，所有内容均来自互联网公开信息。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#about" onClick={(e) => handleScroll(e, '#about')} className="hover:text-primary-500 transition-colors cursor-pointer">关于本站</a>
            <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="hover:text-primary-500 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}